const GLOBAL: any = window;

export default () => {
  if (!GLOBAL.jsonEnumALL || !GLOBAL.jsonEnumALL.INTERNAL_TRAINING_TYPE) {
    return [];
  }

  return GLOBAL.jsonEnumALL.INTERNAL_TRAINING_TYPE.filter((training: any) => training.isActive)
    .map((activeTraining: any) => ({
      code: activeTraining.code,
      name: activeTraining.name,
    }));
};
